import { PipeTransform, Pipe } from '@angular/core';
import { LocalizationService } from '../services/localization.service';

import tData from './translateDataB3000.json';

@Pipe({ name: 't' })
export class TranslatePipe implements PipeTransform {
  constructor(private _LocalizationService: LocalizationService) {}

  transform(value, lang?: string): any {
    if (!value) {
      return '';
    }

    let rt;
    if (lang) {
      try {
        rt = tData[value][lang];

        if (!rt) {
          throw Error('No translation for ');
        }
      } catch {
        rt = tData[value]['en'];
      }
    } else {
      try {
        rt = tData[value][this._LocalizationService.LANGCODE];

        if (!rt) {
          throw Error('No translation for ');
        }
      } catch {
        console.log('No translation for ' + value);
        rt = tData[value]['en'];
      }
    }
    //lang ? rt = tData[value][lang] : rt = tData[value][this._LocalizationService.LANGCODE];

    return rt;
  }
}
